export default __webpack_public_path__ + "static/media/7-min.6e75a14f.PNG";